<div
  class="flex items-center"
  (mouseleave)="resetHover()"
>
  <div
    *ngFor="let star of stars"
    (mouseover)="hoverRating(star)"
    (click)="setRating(star)"
  >
    <ng-icon
      [name]="(hoveredRating || appointment.rating) >= star ? 'heroStarSolid' : 'heroStar'"
      class="text-yellow-400 text-4xl cursor-pointer"
    ></ng-icon>
  </div>
</div>